import * as React from 'react';

var _mask, _path, _g, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgEu = function SvgEu(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_5428_86551)"
    }, _mask || (_mask = /*#__PURE__*/ React.createElement("mask", {
        id: "path-1-outside-1_5428_86551",
        width: 20,
        height: 16,
        x: 2.4,
        y: 4.8,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 4.8h20v16h-20z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2.4 5.8a1 1 0 0 1 1-1h17.2a1 1 0 0 1 1 1v12.4a1 1 0 0 1-1 1H3.4a1 1 0 0 1-1-1z"
    }))), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_5428_86551",
        width: 20,
        height: 16,
        x: 2,
        y: 4,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 4.8h19.2v14.4H2.4z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_5428_86551)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M1.2 4.8v8.64h11.52V4.8z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#039",
        d: "M1.2 4.8h21.6v14.4H1.2z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12 6.4-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12 6.4.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M12.76 6.952h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12.76 6.952-.646.47-.236-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12.47 7.847-.247-.761-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12.47 7.847-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M11.24 6.952h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m11.24 6.952.646.47.235-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m11.53 7.847.247-.761.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m11.53 7.847.647-.47-.235-.324zM12 15.999l-.247.76.38.125z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12 15.999.247.76-.38.125z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M12.76 16.553h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12.76 16.552-.646.47-.236-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12.47 17.446-.247-.76-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m12.47 17.446-.647-.47.235-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M11.24 16.553h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m11.24 16.552.646.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m11.53 17.446.247-.76.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m11.53 17.446.647-.47-.235-.323zM7.2 11.2l-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.2 11.2.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M7.96 11.753h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.96 11.752-.646.47-.236-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.67 12.647-.247-.761-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.67 12.647-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M6.44 11.753h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m6.44 11.752.646.47.235-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m6.73 12.647.247-.761.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m6.73 12.647.647-.47-.235-.324zM9.13 8.491l.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m9.13 8.491.247-.76.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m8.839 7.598.647.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M8.839 7.598h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m9.6 7.044-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m9.6 7.044.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m10.07 8.491-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m10.07 8.491-.247-.76-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m10.36 7.597-.646.47-.236-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M10.36 7.598h-.8v.4zM8.314 10.247l-.247-.76-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m8.314 10.247-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.374 10.246.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.374 10.246.247-.76.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.083 9.352.647.47.236-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M7.083 9.353h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m8.605 9.354-.647.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M8.605 9.354h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.844 8.8.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.844 8.8-.247.76.38.124zM8.604 14.152h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m8.604 14.152-.648.47-.235-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m8.313 15.048-.247-.761-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m8.313 15.048-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.373 15.048.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.373 15.048.247-.761.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.843 13.6.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.843 13.6-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M7.082 14.152h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m7.082 14.152.647.47.235-.323zM10.361 15.91h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m10.361 15.91-.647.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m10.07 16.805-.247-.761-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m10.07 16.805-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m9.13 16.805.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m9.13 16.805.247-.761.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m9.6 15.356.247.761-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m9.6 15.356-.247.761.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M8.84 15.91h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m8.84 15.91.647.47.235-.324zM16.8 11.2l.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.8 11.2-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M16.04 11.753h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.04 11.752.646.47.236-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.33 12.647.247-.761.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.33 12.647.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M17.56 11.753h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m17.56 11.752-.646.47-.236-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m17.27 12.647-.247-.761-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m17.27 12.647-.647-.47.235-.324zM14.87 8.491l-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m14.87 8.491-.247-.76-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m15.16 7.598-.646.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M15.16 7.598h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m14.4 7.044.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m14.4 7.044-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m13.93 8.491.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m13.93 8.491.247-.76.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m13.64 7.597.646.47.236-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M13.64 7.598h.8v.4zM15.686 10.247l.247-.76.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m15.686 10.247.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.626 10.246-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.626 10.246-.247-.76-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.917 9.352-.648.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M16.917 9.353h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m15.395 9.353.647.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M15.395 9.354h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.156 8.8-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.156 8.8.247.76-.38.124zM15.396 14.152h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m15.396 14.152.648.47.235-.323z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m15.687 15.048.247-.761.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m15.687 15.048.647-.47-.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.627 15.048-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.627 15.048-.247-.761-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.157 13.6-.247.76.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.157 13.6.247.76-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M16.918 14.152h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m16.918 14.152-.647.47-.235-.323zM13.639 15.91h.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m13.639 15.91.647.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m13.93 16.805.247-.761.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m13.93 16.805.647-.47-.236-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m14.87 16.805-.647-.47.235-.324z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m14.87 16.805-.247-.761-.38.123z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m14.4 15.356-.248.761.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m14.4 15.356.247.761-.38.124z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "M15.16 15.91h-.8v.4z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FC0",
        d: "m15.16 15.91-.647.47-.235-.324z"
    })))), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#111827",
        fillOpacity: 0.1,
        d: "M2.4 4.8h19.2zm19.2 13.4a2 2 0 0 1-2 2H4.4a2 2 0 0 1-2-2h19.2m-19.2 1V4.8zM21.6 4.8v14.4z",
        mask: "url(#path-1-outside-1_5428_86551)"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_5428_86551"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M2.4 5.8a1 1 0 0 1 1-1h17.2a1 1 0 0 1 1 1v12.4a1 1 0 0 1-1 1H3.4a1 1 0 0 1-1-1z"
    })))));
};

export { SvgEu as ReactComponent };
//# sourceMappingURL=EU.svg.es.js.map
